export const availableTiers = ["challenger", "grandmaster", "master", "diamond", "platinum", "gold", "silver", "bronze", "iron"];

function getTierColor(tier) {
  switch (tier && tier.toLowerCase()) {
    case "iron":
      return "#574D4F";
    case "bronze":
      return "#8C523A";
    case "silver":
      return "#80989D";
    case "gold":
      return "#CD8837";
    case "platinum":
      return "#4E9996";
    case "diamond":
      return "#576BCE";
    case "master":
      return "#9D48E0";
    case "grandmaster":
      return "#CD4545";
    case "challenger":
      return "#F4C874";
    default:
      return "";
  }
}

function tierLetter(tier) {
  switch (tier && tier.toLowerCase()) {
    case "iron":
      return "I";
    case "bronze":
      return "B";
    case "silver":
      return "S";
    case "gold":
      return "G";
    case "platinum":
      return "P";
    case "diamond":
      return "D";
    case "master":
      return "M";
    case "grandmaster":
      return "GM";
    case "challenger":
      return "C";
    default:
      return "U";
  }
}

function letterToTier(tierLetter) {
  switch (tierLetter) {
    case "I":
      return "iron";
    case "B":
      return "bronze";
    case "S":
      return "silver";
    case "G":
      return "gold";
    case "P":
      return "platinum";
    case "D":
      return "diamond";
    case "M":
      return "master";
    case "GM":
      return "grandmaster";
    case "C":
      return "challenger";
    default:
      return "unranked";
  }
}

function getNextTierLetter(tierLetter) {
  switch (tierLetter) {
    case "I":
      return "B";
    case "B":
      return "S";
    case "S":
      return "G";
    case "G":
      return "P";
    case "P":
      return "D";
    case "D":
      return "M";
    case "M":
      return "GM";
    case "GM":
      return "C";
    case "C":
      return "C";
    default:
      return "unranked";
  }
}

function getQueueTypeName(queueType) {
  if (queueType === "RANKED_FLEX_SR") {
    return "flex 5v5";
  } else {
    return "solo/duo";
  }
}

function convertRomanNumeral(roman) {
  if (!roman) return 0;

  switch (roman.toUpperCase()) {
    case "I":
      return 1;
    case "II":
      return 2;
    case "III":
      return 3;
    case "IV":
      return 4;
    case "V":
      return 5;
    default:
      return 0;
  }
}

function convertTierToValue(tier) {
  if (!tier) return 0;

  switch (tier.toLowerCase()) {
    case "challenger":
      return 9;
    case "grandmaster":
      return 8;
    case "master":
      return 7;
    case "diamond":
      return 6;
    case "platinum":
      return 5;
    case "gold":
      return 4;
    case "silver":
      return 3;
    case "bronze":
      return 2;
    case "iron":
      return 1;
    default:
      return 0;
  }
}

function getRankName(ranking) {
  let tier = ranking.tier.charAt(0).toUpperCase() + ranking.tier.slice(1).toLowerCase();
  let displayName;

  if (tier === "Challenger" || tier === "Master") {
    displayName = tier + ", " + ranking.lp + " lp";
  } else if (tier === "Unranked") {
    displayName = "Unranked";
  } else {
    displayName = `${tier} ${convertRomanNumeral(ranking.rank)}, ${ranking.lp} lp`;
  }

  return displayName;
}
function getRankNameNoLp(ranking) {
  let tier = (ranking.tier || "").charAt(0).toUpperCase() + (ranking.tier || "").slice(1).toLowerCase();
  let displayName;

  if (tier === "Challenger" || tier === "Master" || tier === "Grandmaster") {
    displayName = tier;
  } else if (tier === "Unranked") {
    displayName = "Unranked";
  } else {
    displayName = `${tier} ${convertRomanNumeral(ranking.rank)}`;
  }

  return displayName;
}

function getProBuildShortRankName(rank) {
  const tier = rank[0] || "";
  const division = (rank[1] || "").toUpperCase();
  return getShortRankName(getRankNameNoLp({ tier, rank: division }));
}

function getProBuildRankName(rank) {
  const tier = rank[0] || "";
  const division = (rank[1] || "").toUpperCase();
  return getRankNameNoLp({ tier, rank: division });
}

function getShortRankName(displayName) {
  let retVal = displayName;
  if (displayName.indexOf("Unranked") > -1) {
    retVal = "—";
  } else if (displayName.indexOf("Iron ") > -1) {
    retVal = retVal.replace("Iron ", "I");
  } else if (displayName.indexOf("Bronze ") > -1) {
    retVal = retVal.replace("Bronze ", "B");
  } else if (displayName.indexOf("Silver ") > -1) {
    retVal = retVal.replace("Silver ", "S");
  } else if (displayName.indexOf("Gold ") > -1) {
    retVal = retVal.replace("Gold ", "G");
  } else if (displayName.indexOf("Platinum ") > -1) {
    retVal = retVal.replace("Platinum ", "P");
  } else if (displayName.indexOf("Diamond ") > -1) {
    retVal = retVal.replace("Diamond ", "D");
  } else if (displayName.indexOf("Master") > -1) {
    retVal = retVal.replace("Master", "M");
  } else if (displayName.indexOf("Challenger") > -1) {
    retVal = retVal.replace("Challenger", "C");
  } else if (displayName.indexOf("Grandmaster") > -1) {
    retVal = retVal.replace("Grandmaster", "GM");
  }
  return retVal;
}

// returns higher rank
function compareRanks(rank1, rank2) {
  if (rank1 && !rank2) {
    return rank1;
  }
  if (!rank1 && rank2) {
    return rank2;
  }

  const tierDiff = convertTierToValue(rank1.tier) - convertTierToValue(rank2.tier);
  if (tierDiff > 0) {
    // compnare tier
    return rank1;
  } else if (tierDiff < 0) {
    return rank2;
  } else {
    // compare division
    const divisionDiff = convertRomanNumeral(rank1.rank) - convertRomanNumeral(rank2.rank);
    if (divisionDiff > 0) {
      return rank1;
    } else if (divisionDiff < 0) {
      return rank2;
    } else {
      // compare total matcehs played
      const totalMatches1 = (rank1.wins || 0) + (rank1.losses || 0);
      const totalMatches2 = (rank2.wins || 0) + (rank2.losses || 0);
      return totalMatches1 >= totalMatches2 ? rank1 : rank2;
    }
  }
}

function selectRank(queueType, season, rankScores) {
  if (!rankScores) {
    return null;
  }

  let rankToDisplay = undefined;
  // Choose highest rank from ranked solo and flex
  if (queueType === "all") {
    rankToDisplay = rankScores
      .filter((rank) => rank.seasonId === Number(season))
      .filter((rank) => rank.queueType === "ranked_solo_5x5" || rank.queueType === "ranked_flex_sr")
      .filter((rank) => !rank.role)
      .sort(compareRanks);
  } else if (queueType === "ranked_solo_5x5" || queueType === "ranked_flex_sr") {
    rankToDisplay = rankScores
      .filter((rank) => rank.seasonId === Number(season))
      .filter((rank) => rank.queueType === queueType)
      .filter((rank) => !rank.role);
  } else {
    rankToDisplay = rankScores
      .filter((rank) => rank.seasonId === Number(season))
      .filter((rank) => rank.queueType === "ranked_solo_5x5")
      .filter((rank) => !rank.role)
      .sort(compareRanks);
  }

  return rankToDisplay && rankToDisplay[0];
}

export {
  getTierColor,
  tierLetter,
  getProBuildRankName,
  getProBuildShortRankName,
  getRankName,
  getQueueTypeName,
  getShortRankName,
  convertRomanNumeral,
  convertTierToValue,
  compareRanks,
  selectRank,
  letterToTier,
  getNextTierLetter,
};
